import Box from "@material-ui/core/Box";
import React, { FC, useEffect, useState } from "react";
import { Theme } from "@material-ui/core/styles";
import { styled } from "@material-ui/styles";
import { useSelector } from "react-redux";

import AccountsHubSpotUploader from "../../../components/CampaignCreation/AccountsHubSpotUploader";
import CompaniesDashboard from "../../CampaignCreationBasicSlides/SelectHubspotTargetCompaniesSlide/CompaniesDashboard";
import { ReduxApplicationState } from "../../../types/ReduxTypes/ReduxApplicationState";
import { errorToaster } from "../../../helpers/toasters";

const PageRoot = styled("div")({
  flex: 1,
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
});

const Card = styled(Box)(({ theme }: { theme: Theme }) => ({
  background: theme.palette.brand.white,
  border: `1px solid ${theme.palette.brand.gray200}`,
  borderRadius: 10,
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
}));

const CardBody = styled("div")({
  padding: "24px",
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
  overflowY: "auto",
});

const TableSection = styled("div")({
  marginTop: 24,
});

const featureNewDesign = process.env.REACT_APP_FEATURE_NEW_DESIGN === "true";

const TargetCompaniesView: FC = () => {
  const [tierValue, setTierValue] = useState<string[]>([]);
  const [areTargetAccountsOnly, setAreTargetAccountsOnly] = useState(false);
  const [areCompaniesLoading, setAreCompaniesLoading] = useState(false);

  const isCompanySortValuesPending = useSelector((state: ReduxApplicationState) => state.campaignToCreate.isPending);
  const foundCompaniesInfo = useSelector((state: ReduxApplicationState) => state.campaignToCreate.foundCompanyInfo);
  const apiError = useSelector((state: ReduxApplicationState) => state.apiError);

  useEffect(() => {
    if (apiError.apiError) errorToaster(apiError.apiError, 5000);
  }, [apiError]);

  return (
    <PageRoot>
      <Card>
        <CardBody>
          <AccountsHubSpotUploader
            setAreCompaniesLoading={setAreCompaniesLoading}
            useRedesign={featureNewDesign}
            hubSpotSelectorButtonLabel="Get Accounts"
            tierValue={tierValue}
            setTierValue={setTierValue}
            areCompaniesLoading={areCompaniesLoading}
            areTargetAccountsOnly={areTargetAccountsOnly}
            setAreTargetAccountsOnly={setAreTargetAccountsOnly}
          />

          {!isCompanySortValuesPending && (
            <TableSection>
              <CompaniesDashboard
                tierValue={tierValue}
                areTargetAccountsOnly={areTargetAccountsOnly}
                areCompaniesLoading={areCompaniesLoading}
                primarySegments={foundCompaniesInfo?.primarySegments ?? []}
                uniqueSegments={foundCompaniesInfo?.uniqueSegments ?? []}
              />
            </TableSection>
          )}
        </CardBody>
      </Card>
    </PageRoot>
  );
};

export default TargetCompaniesView;
